import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon } from 'lucide-react';
export function GetInvolved() {
  return <section className="py-20 md:py-28 bg-navy-500" aria-labelledby="involved-heading" data-id="element-150">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-152">
          <h2 id="involved-heading" className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-153">
            Help Us Keep Our Community Healthy
          </h2>
          <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto" data-id="element-154">
            If you are interested in volunteering or joining the HCF family,
            let's talk.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-155">
            <a href="#volunteer" className="w-full sm:w-auto inline-flex justify-center items-center bg-white text-navy-500 px-8 py-4 rounded-[10px] font-semibold transition-colors hover:bg-gray-100 min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy-500" data-id="element-156">
              Volunteer Opportunities
            </a>
            <a href="#careers" className="w-full sm:w-auto inline-flex justify-center items-center border-2 border-white text-white px-8 py-4 rounded-[10px] font-semibold transition-colors hover:bg-white/10 min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy-500" data-id="element-157">
              Career Openings
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-white/80 text-lg" data-id="element-158">
            <a href="mailto:info@hcfclinics.com" className="flex items-center gap-3 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-md px-2 py-1" data-id="element-159">
              <MailIcon className="h-6 w-6" data-id="element-160" />
              <span data-id="element-161">info@hcfclinics.com</span>
            </a>
            <a href="tel:7185550100" className="flex items-center gap-3 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-md px-2 py-1" data-id="element-162">
              <PhoneIcon className="h-6 w-6" data-id="element-163" />
              <span data-id="element-164">(718) 555-0100</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}